import { FacilityName } from "../../../shared/services/facility-name.service";
import { FacilityType } from "../../../shared/services/facility-type.service";
import { FormGroup } from "@angular/forms";
import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: 'app-facility-selector',
    templateUrl: './facility-selector.component.html'
  })

export class FacilitySelectorComponent implements OnInit {

    @Input() facilitySelectionGroup: FormGroup;
    @Input() facilityTypes: FacilityType[] = [];
    @Input() label: string;

    private _facilities: FacilityName[];
    @Input() set facilities(value: FacilityName[]) { 
      this.filteredFacilities = value.filter((t => t.facilityTypeId === this.facilityType.value)); 
      this._facilities = value;
    }

    public get facilityType() { return this.facilitySelectionGroup.get('facilityType'); }
    public get facility() { return this.facilitySelectionGroup.get('facility') }
    public filteredFacilities: FacilityName[] = [];

    constructor() {}

    ngOnInit(): void {
      this.facilityType
        .valueChanges
        .subscribe((value: number) => {
          this.filteredFacilities = this._facilities.filter((t => t.facilityTypeId === value));

          if (value === -1) {
            this.facility.patchValue(null);
          }
        })
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-planning-modal/facility-selector/facility-selector.component.ts